import { writable } from 'svelte/store';
import _ from '@centerhealth/common/lodash';
import type { Writable } from 'svelte/store';

// persist local store to local storage
export const wStorage = <T>(key: string, initValue?: T): Writable<T> => {
  const store = writable(initValue);
  if (typeof Storage === 'undefined') return store;

  const storedValueStr = localStorage.getItem(key);
  if (!_.isNil(storedValueStr)) store.set(JSON.parse(storedValueStr));

  store.subscribe((val) => {
    if (_.isUndefined(val)) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(val));
  });
  return store;
};
